/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMediaQuery } from "@mui/material";
import styles from "../Styles/dashboard.module.css";
import { Vocabulary } from "../Utils/Vocabulary";
import MainTable from "../Components/GenericComponents/MainTable";
import { urlEnum } from "../Utils/UrlEnum";
import {
  FiltersModel,
  OrderModel,
  UserModel,
  WorkflowStepModel,
} from "../Utils/Models";
import moment from "moment";
import { dayPilotFormat, euFormatForDateTime } from "../Utils/Config";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AssignToOrderModal from "../Components/TimeTracking/AssignToOrderModal";
import Filters from "../Components/Reports/Filters";

export default function TimeTrackingTable() {
  const location = useLocation();
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [assignToOrderItem, setAssignToOrderItem] = useState<any>(null);
  const [openAssignToOrder, setOpenAssignToOrder] = useState(false);
  const [filters, setFilters] = useState<FiltersModel>({
    startDate: moment().startOf("year"),
    endDate: moment().endOf("month"),
    user: null,
    order: null,
    step: null,
  });

  const timeTrackingHeader = [
    {
      label: Vocabulary.user,
      name: "userId",
      options: {
        sort: false,
        customBodyRender: (value: UserModel | null) => {
          return <>{value ? `${value.name}` : ""}</>;
        },
      },
    },
    {
      label: Vocabulary.order,
      name: "orderId",
      options: {
        sort: false,
        customBodyRender: (value: OrderModel | null) => {
          return <>{value ? value.orderNumber : Vocabulary.noOrderFound}</>;
        },
      },
    },
    {
      label: Vocabulary.step,
      name: "stepId",
      options: {
        sort: false,
        customBodyRender: (value: WorkflowStepModel | null) => {
          return <>{value ? value.name : Vocabulary.noStepFound}</>;
        },
      },
    },
    {
      label: Vocabulary.startTime,
      name: "startTime",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return (
            <>{value ? moment.unix(value).format(euFormatForDateTime) : ""}</>
          );
        },
      },
    },
    {
      label: Vocabulary.endTime,
      name: "endTime",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          return (
            <>
              {value
                ? moment.unix(value).format(euFormatForDateTime)
                : Vocabulary.stillOngoing}
            </>
          );
        },
      },
    },
  ];

  /**
   *
   */
  useEffect(() => {
    const search = location.search.split(/[?&]+/);
    const newFilters: any = {
      startDate: moment().startOf("year"),
      endDate: moment().endOf("month"),
      user: null,
      order: null,
      step: null,
    };
    search.forEach((value: any) => {
      if (value !== "") {
        const values = value.split("=");
        newFilters[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
        if (values[0] === "page") newFilters[values[0]] = +values[1] - 1;
        if (values[1] === "null") newFilters[values[0]] = null;
      }
    });
    setFilters({
      ...newFilters,
      startDate: moment(newFilters.startDate, dayPilotFormat),
      endDate: moment(newFilters.endDate, dayPilotFormat),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <Filters
        filters={filters}
        recalculateReportsButton={false}
        user={{
          show: true,
          multiple: false,
          disableClearable: false,
        }}
        step={{
          show: true,
          multiple: false,
          disableClearable: false,
        }}
        order={{
          show: true,
          multiple: false,
          disableClearable: true,
        }}
      />
      <MainTable
        urlEnumApi={urlEnum.timeTracking}
        header={timeTrackingHeader}
        tableTitle={Vocabulary.timeTrackingList}
        hideOptionButtons={{
          add: true,
          edit: { condition: (item: any) => true },
          delete: { condition: (item: any) => true },
        }}
        tableCustomOptions={{
          showSearch: false,
        }}
        anotherOptionButtons={[
          {
            condition: (item: any) => !item.orderId && !item.stepId,
            icon: (
              <>
                <AssignmentIndIcon style={{ marginRight: 10 }} />
                {Vocabulary.assignToOrder}
              </>
            ),
            title: Vocabulary.assignToOrder,
            action: (item: any) => {
              setAssignToOrderItem(item);
              setOpenAssignToOrder(true);
            },
          },
        ]}
      />
      {openAssignToOrder ? (
        <AssignToOrderModal
          open={openAssignToOrder}
          onClose={() => {
            setOpenAssignToOrder(false);
            setAssignToOrderItem(null);
          }}
          timeTracking={assignToOrderItem}
        />
      ) : null}
    </div>
  );
}
